export const DOCUMENT_CATEGORIES = [
  // Resume is collected as a plain document here (no parsing/scoring) —
  // AI resume scoring happens only via the screening resume-upload step.
  {
    type: 'resume',
    label: 'Resume',
    documents: [{ subtype: 'resume_cv', label: 'Resume / CV' }],
  },
  {
    type: 'govt_id',
    label: 'Government ID',
    documents: [
      { subtype: 'aadhaar_card', label: 'Aadhaar Card' },
      { subtype: 'pan_card', label: 'PAN Card' },
      { subtype: 'passport', label: 'Passport' },
      { subtype: 'driving_licence', label: 'Driving Licence' },
    ],
  },
  {
    type: 'education',
    label: 'Education',
    documents: [
      { subtype: 'degree_certificate', label: 'Degree Certificate' },
      { subtype: 'marksheet', label: 'Marksheet (Final Year)' },
      { subtype: 'provisional_certificate', label: 'Provisional Certificate' },
    ],
  },
  {
    type: 'employment',
    label: 'Previous Employment',
    documents: [
      { subtype: 'uan_number', label: 'UAN (Universal Account Number)' },
      { subtype: 'experience_letter', label: 'Experience / Relieving Letter' },
      { subtype: 'offer_letter', label: 'Offer Letter (previous employer)' },
    ],
  },
  {
    type: 'salary',
    label: 'Salary & Compensation',
    documents: [
      { subtype: 'salary_slips', label: 'Salary Slips (Last 3-6 Months)' },
      { subtype: 'form_16', label: 'Form 16' },
    ],
  },
  {
    type: 'address',
    label: 'Address Proof',
    documents: [
      { subtype: 'utility_bill', label: 'Utility Bill (Electricity / Water / Gas)' },
      { subtype: 'rental_agreement', label: 'Rental Agreement' },
    ],
  },
  {
    type: 'professional',
    label: 'Professional',
    documents: [{ subtype: 'professional_license', label: 'Professional License / Certification' }],
  },
  {
    type: 'photograph',
    label: 'Photograph',
    documents: [
      { subtype: 'passport_photo', label: 'Passport-size Photograph' },
    ],
  },
  {
    type: 'personal_details',
    label: 'Personal Details',
    documents: [
      { subtype: 'complete_address', label: 'Complete Address' },
      { subtype: 'marital_status', label: 'Marital Status' },
    ],
  },
  {
    type: 'bank_details',
    label: 'Bank Details',
    documents: [
      { subtype: 'bank_account', label: 'Bank Account' },
    ],
  },
  // Allows HR to request a custom document label (free text).
  // NOTE: Govt ID docs are blocked in UI + server validation.
  {
    type: 'other',
    label: 'Other',
    documents: [{ subtype: 'custom', label: 'Other (custom)' }],
  },
];

